<template>
    <div
        :class="{'uk-open': !!this.opened}"
        class="uk-button-dropdown"
        @mouseover="maybe_open"
        @mouseleave="maybe_close"
    >
        <base-button
            v-bind="$props"
            @click="toggle"
        >
            <slot></slot>
        </base-button>
        <div class="uk-dropdown uk-dropdown-small">
            <slot name="dropdown"></slot>
        </div>
    </div>
</template>

<script>
import BaseButton from "./BaseButton"

let timer

export default {
    components: {
        BaseButton
    },
    methods: {
        open (timed) {
            if(timer) {
                clearTimeout(timer)
                timer = null
            }
            this.opened = true
            this.timed = timed
        },
        close (timed) {
            if(timed) {
                timer = setTimeout(() => {
                    this.close(false)
                }, 750)
            } else {
                this.opened = false
                this.timed = false
            }
        },
        toggle () {
            if(timer) {
                clearTimeout(timer)
                timer = null
                this.timed = false
            } else if(!this.timed) {
                if(this.opened) this.close(false)
                else this.open(false)
            } else this.timed = false
        },
        maybe_open () {
            // if(!this.opened) this.open(true)
        },
        maybe_close () {
            // if(!!this.opened) this.close(true)
        }
    },
    props: {
        label: {
            type: String,
            validator: prop => !!prop
        },
        type: {
            type: String,
            default: "button"
        },
        flavor: {
            type: String,
            validator: prop => !prop || prop.match(/^(link|normal)$/i),
            default: "normal"
        },
        color: {
            type: String,
            validator: prop => !prop || prop.match(/^(primary|secondary|regular|success|danger)$/i),
            default: "regular"
        },
        size: {
            type: String,
            validator: prop => !prop || prop.match(/^(mini|small|medium|large)$/i),
            default: "medium"
        },
        block: {
            type: Boolean,
            default: false
        },
        active: {
            type: Boolean,
            default: false
        },
        waiting: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            opened: false,
            timed: false
        }
    }
}
</script>
